// clientRoutes.ts
import { defineAsyncComponent } from 'vue'
import type { RouteRecordRaw } from 'vue-router'
import { Actions, Subjects } from '@/rules/abilityTypes'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/user/:slug(.*)?',
    name: 'user',
    component: defineAsyncComponent(() => import('../views/UserList.vue')),
    meta: {
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.USER,
      action: Actions.READ
    }
  },
  {
    path: '/user/:userId/:slug(.*)?',
    name: 'userEdit',
    component: () => import('../views/UserEdit.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.USER,
      action: Actions.WRITE
    }
  },
  {
    path: '/user_detail/:userId/:date/:cellWidth?_:unit?_:amount?/:slug(.*)?',
    name: 'userDetail',
    component: () => import('../views/UserDetail.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.USER_DETAIL,
      action: Actions.READ
    }
  },
  {
    path: '/employment/:employmentId/:userId/:slug(.*)?',
    name: 'employmentEdit',
    component: () => import('../views/EmploymentEdit.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.USER,
      action: Actions.WRITE
    }
  },
  {
    path: '/worksheet/:month/:slug(.*)?',
    name: 'worksheet',
    props: true,
    component: defineAsyncComponent(() => import('../views/WorkSheet.vue')),
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.ATTENDANCE,
      action: Actions.READ
    }
  },
  {
    path: '/work/:day(\\d{4}-\\d{2}-\\d{2})/:slug(.*)?',
    name: 'work',
    props: true,
    component: () => import('../views/WorkEdit.vue'),
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.ATTENDANCE,
      action: Actions.WRITE
    }
  },
  {
    path: '/change_password',
    name: 'changePassword',
    component: () => import('../views/ChangePassword.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.CHANGE_MY_PASSWORD,
      action: Actions.WRITE
    }
  }
]

export default routes
